import { handleResponse, handleError } from "./apiUtils";
import { API, graphqlOperation } from 'aws-amplify';
import moment from 'moment';
import * as queries from '../graphql/queries';
import * as mutations from '../graphql/mutations';
import getOffsetTime from '../utils/getOffsetTime';
import demoParams from '../__test__/demoParams';
import _ from 'underscore';

const {
    demoMode,
    demoDayTypeCalendarResourceId,
    demoDayTypeCalendarShowFutureDays,
    demoDayTypeCalendarUserId
} = demoParams;

/**
 * Returns an array of day types for the user over the next 365 days
 * @param {*} resourceId
 * @param {*} year - current year
 * @param {*} month - current month
 * @param {*} showFutureDays - from user.securityLevels
 * @param {*} userId
 */

export async function getDayTypeCalendar(resourceId, year, month, showFutureDays, userId) {

    let response = await API.graphql(graphqlOperation(queries.dayTypeApIgetDayTypeCalendar,
        {
            resourceId: demoMode ? demoDayTypeCalendarResourceId : resourceId,
            year,
            month,
            showFutureDays: demoMode ? demoDayTypeCalendarShowFutureDays : showFutureDays,
            userId: demoMode ? demoDayTypeCalendarUserId : userId
        }));
    return response.data.dayTypeAPIgetDayTypeCalendar;
}


export async function getDayTypeSecurity(userId, dayTypeId) {
    let dayTypeSecurity = await API.graphql(graphqlOperation(queries.dayTypeApIgetDayTypeSecurity,
        {
            userId: demoMode ? demoDayTypeCalendarUserId : userId,
            dayTypeId
        }));

    return dayTypeSecurity.data.dayTypeAPIgetDayTypeSecurity;
}

export async function createDayType(parameters) {

    parameters.ipAddress = '27.0.0.1';

    let response = await API.graphql(graphqlOperation(mutations.dayTypeApIcreateDayTypeRequests, parameters))
        .catch(handleError);

    return response.data.dayTypeAPIcreateDayTypeRequests;
}

export async function updateDayType(parameters) {

    parameters.ipAddress = '27.0.0.1';

    let response = await API.graphql(graphqlOperation(mutations.dayTypeApIupdateDayTypeRequests, parameters))
        .catch(handleError);

    return response.data.dayTypeAPIupdateDayTypeRequests;
}

export async function deleteDayType(parameters) {

    parameters.ipAddress = '27.0.0.1';

    let response = await API.graphql(graphqlOperation(mutations.dayTypeApIdeleteDayTypeRequests, parameters))
        .catch(handleError);

    return response.data.dayTypeApIdeleteDayTypeRequests;
}


export async function createResourceDayType(parameters) {

    parameters.IPAddress = '27.0.0.1';

    let response = await API.graphql(graphqlOperation(mutations.dayTypeApIcreateResourceDayType, parameters))
        .catch(handleError);

    return response.data.dayTypeAPIcreateResourceDayType;
}

export async function updateResourceDayType(parameters) {

    parameters.IPAddress = '27.0.0.1';
    console.log('parameters', parameters);

    let response = await API.graphql(graphqlOperation(mutations.dayTypeApIupdateResourceDayType, parameters))
        .catch(handleError);

    return response.data.dayTypeAPIupdateResourceDayType;
}

export async function updateResourceDayTypeComment(parameters) {

    parameters.IPAddress = '27.0.0.1';
    console.log('parameters', parameters);

    let response = await API.graphql(graphqlOperation(mutations.dayTypeApIupdateResourceDayTypeComment, parameters))
        .catch(handleError);

    return response.data.dayTypeAPIupdateResourceDayTypeComment;
}

export async function getDayTypeRequestsByYear(resourceId, year, month) {
    let showInRequest = false;

    let getDayTypeRequestsByYearPlusOne = await API.graphql(graphqlOperation(queries.dayTypeApIgetDayTypeRequestsByYear,
        {
            resourceId,
            showInRequest,
            year: year + 1,
            month: 1
        }));

    let getDayTypeRequestsByYear = await API.graphql(graphqlOperation(queries.dayTypeApIgetDayTypeRequestsByYear,
        {
            resourceId,
            showInRequest,
            year,
            month: 1
        }));

    let getDayTypeRequestsByYearMinusOne = await API.graphql(graphqlOperation(queries.dayTypeApIgetDayTypeRequestsByYear,
        {
            resourceId,
            showInRequest,
            year: year - 1,
            month: 1
        }));

    let combinedArray = getDayTypeRequestsByYearPlusOne.data.dayTypeAPIgetDayTypeRequestsByYear.dayTypeRequests.reverse()
        .concat(getDayTypeRequestsByYear.data.dayTypeAPIgetDayTypeRequestsByYear.dayTypeRequests.reverse(),
            getDayTypeRequestsByYearMinusOne.data.dayTypeAPIgetDayTypeRequestsByYear.dayTypeRequests.reverse());
    let dayTypeRequestsArray = await addOffsetToTimes(combinedArray);

    let dayTypeRequests = {
        resourceId,
        year,
        dayTypeRequestsArray
    }
    return dayTypeRequests;
}

export async function getResourceDayTypeByDate(resourceId, date) {
    let response = await API.graphql(graphqlOperation(queries.dayTypeApIgetResourceDayTypeByDate, { resourceId, date }))
        .catch(handleError);

    console.log('data', response.data.dayTypeAPIgetResourceDayTypeByDate)


    return response.data.dayTypeAPIgetResourceDayTypeByDate;
}

export async function getResourceDayTypeById(resourceDayTypeId) {
    let response = await API.graphql(graphqlOperation(queries.dayTypeApIgetResourceDayTypeById, resourceDayTypeId))
        .catch(handleError);

    let resourceDayType = response.data.dayTypeAPIgetResourceDayTypeById;
    let resourceDayTypeOffset = await addOffsetToTimes(resourceDayType.data);
    resourceDayType.data = resourceDayTypeOffset;
    return resourceDayType;
}

export async function getDayTypesAll(isApprover, resourceId, date, userId) {
    let response = await API.graphql(graphqlOperation(queries.dayTypeApIgetDayTypesAll, { isApprover, resourceId, date, withForceTour: true, userId: userId }))
        .catch(handleError);

    return response.data.dayTypeAPIgetDayTypesAll;
}

export async function getDayTypesAllWithoutForceTour(params) {
    let response = await API.graphql(graphqlOperation(queries.dayTypeApIgetDayTypesAll, params))
        .catch(handleError);

    return response.data.dayTypeAPIgetDayTypesAll;
}

export async function deleteResourceDayTypes(resourceId, fromDate, toDate, userId) {
    const IPAddress = '27.0.0.1';
    let response = await API.graphql(graphqlOperation(mutations.dayTypeApIdeleteResourceDayTypes, { resourceId, fromDate, toDate, userId, IPAddress }))
        .catch(handleError);

    return response.data.dayTypeAPIdeleteResourceDayTypes;
}

export async function deleteResourceDayType(parameters) {
    parameters.IPAddress = '27.0.0.1';
    let response = await API.graphql(graphqlOperation(mutations.dayTypeApIdeleteResourceDayType, parameters))
        .catch(handleError);

    return response.data.dayTypeAPIdeleteResourceDayType;
}

export async function getDayTypeRequestById(parameters) {
    let getDayTypeRequestById = await API.graphql(graphqlOperation(queries.dayTypeApIgetDayTypeRequestById, parameters))
        .catch(handleError);

    let dayTypeRequest = getDayTypeRequestById.data.dayTypeAPIgetDayTypeRequestById.dayTypeRequests;
    let dayTypeRequestOffset = await addOffsetToTimes(dayTypeRequest);
    return dayTypeRequestOffset;
}

export async function getDayTypesByDayRule(parameters) {
    let response = await API.graphql(graphqlOperation(queries.dayTypeApIgetDayTypesByResourceDayRule, parameters))
        .catch(handleError);
    return response.data.dayTypeAPIgetDayTypesByResourceDayRule;
}

export async function getDayTypesAllowingTourScheduling(parameters) {
    let response = await API.graphql(graphqlOperation(queries.dayTypeApIgetDayTypesAllowingTourScheduling, parameters))
        .catch(handleError);
    return response.data.dayTypeAPIgetDayTypesAllowingTourScheduling;
}

export async function getHasHolidays(parameters) {

    let response = await API.graphql(graphqlOperation(queries.dayTypeApIgetHasHolidays, parameters))
        .catch(handleError);

    return response.data.dayTypeAPIgetHasHolidays;
}

const addOffsetToTimes = async (array) => {
    let arrayCopy = [];
    array.forEach((dayType, index) => {
        let dayTypeCopy = { ...dayType }

        arrayCopy[index] = dayTypeCopy;

        if (arrayCopy[index].date) {
            let dateOffset = getOffsetTime(moment(dayTypeCopy.date)._d);
            arrayCopy[index].date = moment(dayTypeCopy.date).add(dateOffset, 'minutes').format();
        }
        if (arrayCopy[index].fromDate) {
            let fromDateOffset = getOffsetTime(moment(dayTypeCopy.fromDate)._d);
            arrayCopy[index].fromDate = moment(dayTypeCopy.fromDate).add(fromDateOffset, 'minutes').format();
        }
        if (arrayCopy[index].toDate) {
            let toDateOffset = getOffsetTime(moment(dayTypeCopy.toDate)._d);
            arrayCopy[index].toDate = moment(dayTypeCopy.toDate).add(toDateOffset, 'minutes').format();
        }
        if (arrayCopy[index].fromTime) {
            let fromTimeOffset = getOffsetTime(moment(arrayCopy[index].fromTime)._d);
            arrayCopy[index].fromTime = moment(dayTypeCopy.fromTime).add(fromTimeOffset, 'minutes').format();
        }
        if (arrayCopy[index].toTime) {
            let toTimeOffset = getOffsetTime(moment(arrayCopy[index].toTime)._d);
            arrayCopy[index].toTime = moment(dayTypeCopy.toTime).add(toTimeOffset, 'minutes').format();
        }
    });

    return arrayCopy;
}



// WEBPACK FOOTER //
// ./src/api/dayTypeApi.js